import otherReducer from "./otherSlice";

export default otherReducer;
